// extracted by mini-css-extract-plugin
export default {"wrapperDark":"Wrapper_wrapperDark__Gz0Qw","wrapperLight":"Wrapper_wrapperLight__fMMPJ"};